import './CustomerTypeSwitch.css';
import { UiContainer } from '../../../state/ui';
import { useTranslation } from '../../../i18n/i18n';
import axios from 'axios';
import { useConfig } from '../../../config';
import { ApiActionResponse } from '../../../types';

export const CustomerTypeButton = (): JSX.Element => {
	const ui = UiContainer.useContainer();
	const t = useTranslation().generic;
	const customerTypeTrans = useTranslation().customerTypeModal;

	const { api } = useConfig();

	const withoutVat = () => {
		if (ui.priceWithVat) {
			ui.togglePriceWithVat();
			axios
				.post<ApiActionResponse>(`${api}customer-type.json`, 'company', {
					withCredentials: true,
				})
				// a background sync of state the ui has already applied; the rejection has to be taken
				.catch(() => undefined);
			ui.setCustomerType('company');
			//cookieService.write('customer-type', 'company', 365);
		}
	};

	const withVat = () => {
		if (!ui.priceWithVat) {
			ui.togglePriceWithVat();
			axios
				.post<ApiActionResponse>(`${api}customer-type.json`, 'private', {
					withCredentials: true,
				})
				// a background sync of state the ui has already applied; the rejection has to be taken
				.catch(() => undefined);
			ui.setCustomerType('private');
			//cookieService.write('customer-type', 'private', 365);
		}
	};

	return (
		<>
			<hr />
			<div className="customer-type-switch-grid">
				<span className={`vat-text company ${!ui.priceWithVat ? 'active' : ''}`} onClick={withoutVat}>
					{customerTypeTrans.company}
					<p>{t.exVat}</p>
				</span>
				<div id="customer-type-switch">
					<div
						className={`switch ${ui.priceWithVat ? 'on' : ''}`}
						onClick={ui.priceWithVat ? withoutVat : withVat}
					>
						<div className="ball" />
					</div>
				</div>
				<span className={`vat-text private ${ui.priceWithVat ? 'active' : ''}`} onClick={withVat}>
					{customerTypeTrans.private}
					<p>{t.incVat}</p>
				</span>
			</div>
		</>
	);
};
